var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { dashboardUrl } from '@web/router/urls';
import { t } from 'i18next';
import { Link } from 'react-router-dom';
var WorkalizerLogo = function () { return (_jsxs(Link, __assign({ to: dashboardUrl, className: "inline-flex shrink-0 items-center opacity-80 transition-opacity hover:opacity-100" }, { children: [_jsx("span", __assign({ className: "sr-only" }, { children: t('header.title') })), _jsx("span", __assign({ className: "inline-flex items-center" }, { children: _jsx("img", { alt: "", src: "/assets/img/workalizer-logo-2.svg", className: "block h-[45px] w-[45px] object-contain object-left" }) }))] }))); };
export default WorkalizerLogo;
